import { dcpcApi } from './dcpcApi';
import { ENTITY_PARAMS_TAG } from './vocEntityParamsApi';

export const STATION_ENTITY_TAG = 'stationEntityTag';

dcpcApi.enhanceEndpoints({ addTagTypes: [STATION_ENTITY_TAG] });
const stationEntityApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({
    getStationEntityWithoutParentByStationId: builder.query({
      query: (stationId) => `station/${stationId}/entities`,
      providesTags: [STATION_ENTITY_TAG],
    }),

    getChildrenEntityByEntityParentId: builder.query({
      query: (parentEntityId) => `entities/${parentEntityId}/children`,
      providesTags: [STATION_ENTITY_TAG],
    }),

    getEntityParamsByEntityId: builder.query({
      query: (entityId) => `entities/${entityId}/parameters`,
      providesTags: [STATION_ENTITY_TAG, ENTITY_PARAMS_TAG],
    }),

    getStationEntityById: builder.query({
      query: (id) => `entities/${id}`,
      providesTags: [STATION_ENTITY_TAG],
    }),

    createStationEntity: builder.mutation({
      query: (body) => ({
        url: '/entities',
        method: 'POST',
        body,
      }),
      invalidatesTags: [STATION_ENTITY_TAG],
    }),

    deleteStationEntity: builder.mutation({
      query: (id) => ({
        url: `entities/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [STATION_ENTITY_TAG],
    }),

    getEntitiesByFilter: builder.query({
      query: (params) => ({
        url: '/entities',
        method: 'GET',
        params,
      }),
      providesTags: [STATION_ENTITY_TAG, ENTITY_PARAMS_TAG],
    }),
  }),
});

export const {
  useGetEntitiesByFilterQuery,
  useGetStationEntityWithoutParentByStationIdQuery,
  useGetChildrenEntityByEntityParentIdQuery,
  useGetEntityParamsByEntityIdQuery,

  useCreateStationEntityMutation,
  useGetStationEntityByIdQuery,
  useDeleteStationEntityMutation,
} = stationEntityApi;
